import React from 'react';
import AdminSidebar from './AdminSidebar';

interface AdminLayoutProps {
  children: React.ReactNode;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  return (
    <div className="app-container">
      <AdminSidebar />
      <main className="main-content">
        {children}
      </main>
    </div>
  );
};

export default AdminLayout;
